import { makeStyles } from "@mui/styles";
import { color } from "../../../Config/theme";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "3% !important",
    marginBottom: "50px !important",
    "@media (max-width:1024px)": {
      marginTop: "3% !important",
    },
    "@media (max-width:425px)": {
      marginTop: "6% !important",
    },
  },
  tabStyle: {
    "& > div": {
      "@media (max-width:768px)": {
        overflow: "scroll !important",
        "&::-webkit-scrollbar": {
          display: "none !important",
        },
      },
    },
  },
  listContainerStyle: {
    marginTop: 25,
    width: "100%",
    "@media (max-width:768px)": {
      marginTop: 40,
    },
  },
  postJobDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 25,
    "@media (max-width:425px)": {
      flexDirection: "column",
    },
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
    "@media (max-width:425px)": {
      marginTop: 10,
    },
  },
  switchTextStyle: {
    color: color.primary,
    fontFamily: "PoppinsLight !important",
  },
  regularFont: {
    fontFamily: "PoppinsRegular !important",
  },
  noDataView: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 400,
  },
  sectionTitle: {
    color: color.primary,
    fontFamily: "PoppinsSemiBold !important",
    fontSize: "20px !important",
  },
  loaderView: {
    width: "100%",
    minHeight: 400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
